export class Adata {
   // ACODE :number;
   // ANAME :string;
   // DIS_CODE:number;
   // DIS_NAME :string;
   // ST_NAME :string;
   // ST_CODE:number;

   ACODE :number;
    ANAME :string;
    ANAME_LL :string;
 AABBR:string;
        ATYPE :string;
     STD_CODE :number;
      DIS_CODE:number;
   SUB_DIS_CODE 
    PINCODE:number;
    POST :string;
    POST_LL :string;
   ENTRY_ID :string;
  
}

export class Search{
   SearchCriteria:string;
   SearchText:string;
   SearchRows:number;
}


// WEBPACK FOOTER //
// ./src/app/shared/adata.model.ts